import React from "react";
import { uploadRequest } from "../../utils/globals";
import { NotificationManager } from "react-notifications";
import "./components/modal.scss";
import { Button, Icon, Modal } from "@plum-xoxo/admin-dsm";
import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";
import styled from "styled-components";

const LogoPlaceHolder = styled.div`
  background: ${(props) => props.theme.palette.light.c100};
  border-radius: 4px;
  border: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
  img {
    height: 40px;
    object-fit: cover;
  }
`;
class EditLogoModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isUploading: false,
      showError: false,
      errMsg: "",
      uploadedLogoUrl: "",
      isSaveDisabled: true,
    };
  }

  componentDidMount() {
    this.setState({ uploadedLogoUrl: this.props.logoSrc });
  }

  uploadTemplateImages = (data) => {
    const imgResp = data.target.files;
    this.setState({ isUploading: true });
    if (imgResp == "") {
      this.setState({ errMsg: "Please Select File", showError: true });
      return setTimeout(
        function () {
          this.setState({ errMsg: "", showError: false });
        }.bind(this),
        2000
      );
    }
    if (imgResp && imgResp[0]) {
      if (
        imgResp[0].type === "image/png" ||
        imgResp[0].type === "image/jpeg" ||
        imgResp[0].type === "image/jpg"
      ) {
        this.setState({
          showError: false,
          errMsg: "",
        });
      } else {
        this.setState({
          showError: true,
          errMsg:
            "Image format not supported. Please upload recommended size and format.",
          isUploading: false,
        });
        return false;
      }
    }
    const maxHeight = 80;
    const maxWidth = 240;
    if (imgResp && imgResp[0]) {
      let img = new Image();
      img.src = window.URL.createObjectURL(imgResp[0]);
      img.onload = () => {
        let invalidDimension = img.width > maxWidth || img.height > maxHeight;
        let invalidSize = imgResp[0].size > 100000;

        if (invalidDimension && invalidSize) {
          this.setState({
            showError: true,
            errMsg:
              "The image could not be uploaded due to invalid size and dimension. Try again with recommended size and dimension.",
            isUploading: false,
            isSaveDisabled: true,
          });
          return false;
        } else if (invalidDimension) {
          this.setState({
            showError: true,
            errMsg:
              "The image could not be uploaded due to invalid dimension. Try again with recommended dimension.",
            isUploading: false,
            isSaveDisabled: true,
          });
          return false;
        } else if (invalidSize) {
          this.setState({
            showError: true,
            errMsg:
              "The image could not be uploaded due to invalid size. Try again with recommended size.",
            isUploading: false,
            isSaveDisabled: true,
          });
          return false;
        } else {
          this.setState({
            showError: false,
            errMsg: "",
            isSaveDisabled: false,
          });
          return true;
        }
      };
    }

    setTimeout(() => {
      const isError = this.state.showError;
      if (!isError) {
        const formData = new FormData();
        formData.append("attachments", imgResp[0]);
        formData.append("logo", true);
        formData.append("isCampaignLanding", 0);
        uploadRequest(
          formData,
          function (response) {
            if (
              response !== undefined &&
              response.error == false &&
              response.data[0]
            ) {
              this.setState({
                isUploading: false,
                showError: false,
                errMsg: "",
                uploadedLogoUrl: response.data[0],
              });
              NotificationManager.success(
                "Logo uploaded successfully.",
                "success"
              );
            } else {
              this.setState({
                isUploading: false,
                showError: false,
                errMsg: "",
              });
              NotificationManager.error(
                response.error ? response.msg : "",
                "Error"
              );
            }
          }.bind(this),
          "/api/graph/uploadTemplateImages"
        );
      } else {
        this.setState({ isUploading: false });
        return;
      }
    }, 200);
  };
  emptyOldFile = (event) => {
    const { target = {} } = event || {};
    target.value = "";
  };

  handleModalSave = () => {
    this.props.setNewLogo(this.state.uploadedLogoUrl);
    this.props.toggleModal();
  };

  render() {
    const { isUploading, errMsg, showError, uploadedLogoUrl } = this.state;
    const { toggleModal } = this.props;
    return (
      <Modal
        isOpen={true}
        style={{ width: "476px", minWidth: "476px" }}
        disableCloseButton={false}
        onClose={() => {
          toggleModal();
        }}
      >
        <Typography
          component="div"
          className="d-flex justify-content-between align-items-center"
        >
          <Typography.H2>Edit Logo</Typography.H2>
          {/* <Icon
            iconName="Close"
            onClick={() => {
              toggleModal();
            }}
            size="m"
          />
           */}
        </Typography>

        <div>
          <LogoPlaceHolder className="py-28 mt-12 logoPlaceholder text-center">
            <img src={uploadedLogoUrl} />
          </LogoPlaceHolder>
          <div className="">
            {showError ? (
              <Typography className="mb-0 mt-4 mb-12" color="red" shade="c200">
                {errMsg}
              </Typography>
            ) : null}
          </div>
          <div>
            <Typography component="div">
              <Typography component="span" color="dark" shade="c200">
                Maximum dimension:{" "}
              </Typography>
              <Typography component="span" color="dark" shade="c300">
                240x80{" "}
              </Typography>
              <Typography component="span" color="dark" shade="c200">
                Maximum size:{" "}
              </Typography>
              <Typography component="span" color="dark" shade="c300">
                100KB{" "}
              </Typography>
            </Typography>
            <Typography component="div">
              <Typography component="span" color="dark" shade="c200">
                Accepted formats:{" "}
              </Typography>
              <Typography component="span" color="dark" shade="c300">
                PNG{" "}
              </Typography>
            </Typography>
          </div>

          <div className="d-flex justify-content-between mt-32">
            <div>
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                id="newlogoupload"
                className="d-none"
                onChange={(e) => this.uploadTemplateImages(e)}
                onClick={this.emptyOldFile}
              />
              <label htmlFor="newlogoupload">
                <Button variant="outlined" color="primary" component="span">
                  Upload New
                </Button>
              </label>
            </div>
            <Button
              disabled={this.state.isUploading || this.state.isSaveDisabled}
              color="primary"
              onClick={() => this.handleModalSave()}
              loading={this.state.isUploading}
            >
              Save
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default EditLogoModal;
